import { dateService, FORMATS } from '@/global/services/date'
import { cloneDeep } from '@/global/utils/utils'
import store from '@/global/store'
import tabsHelper from '../tabs-helper'
export default {
  name: 'Sketch',

  mixins: [
    tabsHelper
  ],

  data () {
    return {
      showLoader: false,
      sketchProductsRefreshCounter: 0
    }
  },

  computed: {
    sketchConfig () {
      return {
        title: this.$t('road-maintenance/aggregator.sketch'),
        key: 'sketch',
        visible: this.$route.query.category !== 'request_new',
        apiConfig: {
          get: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/sketch`,
            method: 'get'
          }
        },
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('road-maintenance/aggregator.sketch'),
            showEditButtons: false,
            showBackButton: {
              onGoBack: () => this.goBack()
            },
            additional_buttons: [
              {
                type: 'base',
                appendIcon: 'mdi-refresh',
                click: async (event) => {
                  const { fetchTabData } = event || {}
                  await fetchTabData?.()
                  this.sketchProductsRefreshCounter++
                }
              },
              {
                type: 'base',
                label: this.$t('fleet/documents/prl_cargo.change_status'),
                prependIcon: 'mdi-swap-horizontal',
                click: (event) => this.onChangeStatus(event),
                visible: !!this.permissions?.canChangeStatus
              }
            ]
          },
          {
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-internal-blocks-main',
            wrapperClasses: 'aggregator-requests-subject-wrapper',
            titleClasses: 'aggregator-requests-internal-title',
            title: this.$t('road-maintenance/aggregator.document_flow'),
            visible: true,
            buttons: [
              {
                label: this.$t('road-maintenance/aggregator.new_document'),
                color: '#65AD45',
                prependIcon: 'mdi-plus',
                prependIconStyle: { color: '#FFFFFF !important' },
                style: { color: '#FFFFFF !important' },
                click: (event) => this.onUploadSketch(event)
              }
            ],
            columnsConfig: [
              {
                key: 'created_at',
                title: this.$t('fleet/documents/prl_cargo.creation_date') + ':',
                valueClass: 'history-block-value',
                customValue: (data) => {
                  return data?.created_at ? dateService.formatCustom(data.created_at, FORMATS.isoDatetime, FORMATS.date) : ''
                }
              },
              {
                key: 'description',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance/patrol-service.description') + ':'
              },
              {
                key: 'created_by',
                valueClass: 'history-block-value',
                title: this.$t('fleet/vehicle_reservation.created_by') + ':'
              },
              {
                key: 'document_name',
                title: this.$t('road-maintenance/aggregator.document') + ':',
                valueClass: 'history-block-value',
                showLoader: this.showLoader,
                prependImage: {
                  src: '/img/icons/pdf-icon.svg',
                  style: {
                    marginRight: '4%'
                  }
                },
                contentWrapperStyle: {
                  display: 'flex',
                  alignItems: 'center'
                },
                click: (event) => this.downloadSketch(event)
              }
            ],
            dataKey: 'sketches'
          },
          {
            component: () => import('../../components/SketchProductsSection.vue'),
            visible: true,
            props: {
              refreshCounter: this.sketchProductsRefreshCounter
            }
          }
        ]
      }
    }
  },

  methods: {
    onUploadSketch (event) {
      const { formData, updateData, fetchTabData } = event || {}
      this.$set(this.uploadSketchDialogConfig, 'showDialog', true)
      this.$set(this.uploadSketchDialogConfig.config, 'formData', cloneDeep(formData))
      this.$set(this.uploadSketchDialogConfig.config, 'updateData', (val) => updateData(val))
      if (typeof fetchTabData === 'function') {
        this.$set(this.uploadSketchDialogConfig.config, 'fetchTabData', () => fetchTabData())
      }
    },

    async downloadSketch (event) {
      let objectURL = null

      try {
        const {
          id: sketchId
        } = event?.rowData || {}

        if (!sketchId) {
          store.dispatch('base/notifications/push', this.$t('road-maintenance/aggregator.invalid_file_id'))
          return
        }
        if (this.showLoader) {
          return
        }

        this.showLoader = true
        const url = new URL(`${window.location.origin}/api/road-maintenance/traffic-regulation/${this.$route.params.id}/attachment/${sketchId}`)

        const response = await fetch(url.toString(), {
          method: 'POST'
        })

        if (!response.ok) {
          const contentType = response.headers.get('Content-type') || ''

          let errorMessage
          if (contentType.includes('text/plain')) {
            // Laravel returned plain text
            errorMessage = await response.text()
          }
          else if (contentType.includes('application/json')) {
            // Laravel returned JSON
            const errorData = await response.json()
            errorMessage = errorData.message || JSON.stringify(errorData)
          }
          else {
            // Probably HTML (default Laravel error page)
            errorMessage = this.$t('road-maintenance/aggregator.not_possible_download_document')
          }

          await store.dispatch('base/notifications/push', errorMessage)
          return
        }

        const contentType = response.headers.get('Content-type')
        const contentDisposition = response.headers.get('Content-Disposition')
        const arrayBuffer = await response.arrayBuffer()

        // Create a Blob from the response data
        const blob = new Blob([new Uint8Array(arrayBuffer)], {
          type: contentType
        })

        // Generate object URL for downloading
        objectURL = URL.createObjectURL(blob)
        const filename = contentDisposition?.split('filename=')[1] ?? 'File'

        // Trigger download
        const link = document.createElement('a')
        link.href = objectURL
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
      catch (exception) {
        console.error(exception.message || exception)
      }
      finally {
        if (objectURL) {
          URL.revokeObjectURL(objectURL)
        }
        this.showLoader = false
      }
    }
  }
}
